const initialState = {
  tenants: [],
  tenantsLoading: false,
  currentTenant: (() => {
    try { return JSON.parse(sessionStorage.getItem('tenant') || '{}') || {}; } catch { return {}; }
  })(),
};

const userReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'GET_TENANTS_LOADING':
      return { ...state, tenantsLoading: true };
    case 'GET_TENANTS_COMPLETED':
      return { ...state, tenants: action.payload, tenantsLoading: false };
    case 'GET_TENANTS_ERROR':
      return { ...state, tenants: [], tenantsLoading: false };
    case 'SET_CURRENT_TENANT':
      return { ...state, currentTenant: action.payload || {} };
    default:
      return state;
  }
};

export default userReducer;